import type {
  ExtranetTripCancellationReason,
  ExtranetTripOutput,
  ExtranetTripStatus,
  TripStatusFilter,
} from '../../types/extranet-api.types';

/**
 * Helpers d'accès ExtranetTripOutput → vue front "ride".
 *
 * Le back livre un shape dédié extranet : la plupart des helpers se réduisent
 * à des accès directs aux champs. On garde la couche pour 2 raisons :
 *   1. Compat des composants qui les appellent déjà.
 *   2. Le `getAmountEuros` qui convertit les centimes (le back livre en centimes).
 */

export const getRideStatus = (trip: ExtranetTripOutput): ExtranetTripStatus => trip.status;

export const getCancellationReason = (trip: ExtranetTripOutput): ExtranetTripCancellationReason | null =>
  trip.cancellationReason;

export const getExternalRef = (trip: ExtranetTripOutput): string => trip.externalRef ?? '';

export const getContractRef = (trip: ExtranetTripOutput): string => trip.contractRef ?? '';

export const getCity = (trip: ExtranetTripOutput): string => trip.city ?? '';

export const getPickupAtISO = (trip: ExtranetTripOutput): string => trip.pickupAt;

/** Convertit les centimes back → euros front (1 décimale d'arrondi). */
export const getAmountEuros = (trip: ExtranetTripOutput): number => trip.amount / 100;

/** Filtre `status[]` de `GET /v1/trips` — vue aplatie, dans l'ordre d'affichage. */
export const TRIP_STATUS_FILTERS: readonly TripStatusFilter[] = [
  'upcoming',
  'on_duty',
  'served',
  'no_show_passenger',
  'passenger_cancel',
  'allocab_cancel',
];

export const TRIP_STATUS_FILTER_LABELS: Record<TripStatusFilter, string> = {
  upcoming: 'À venir',
  on_duty: 'En cours',
  served: 'Servie',
  no_show_passenger: 'No-show passager',
  passenger_cancel: 'Annulation passager',
  allocab_cancel: 'Annulation Allocab',
};
